import { api } from './client'

// Foundations — daily depth prompt appended to the check-in flow.
// Token is passed explicitly by callers (same pattern as rci.js).
export const foundationsApi = {
  getTodayPrompt: (token) => api.get('/foundations/today', token),
  submitResponse: (dayNumber, responseValue, token) =>
    api.post('/foundations/response', { day_number: dayNumber, response_value: responseValue }, token),
  getProfile: (token) => api.get('/foundations/profile', token),
  getStatus: (token) => api.get('/foundations/status', token),
}
